import { createFileRoute } from "@tanstack/react-router"

import { AdminAccountDetailPage } from "@/pages/admin/account-detail"

export const Route = createFileRoute("/_authenticated/admin/accounts/$id")({
  component: AdminAccountDetailPage,
})
